module.exports = __webpack_public_path__ + "assets/order-by-desc.c8fdacd6.svg";